module.exports = __webpack_public_path__ + "static/media/brazil.15c6fd0d.png";